module.exports = __webpack_public_path__ + "static/img/news4.1f2fd70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news4.jpg
// module id = hb11
// module chunks = 1